import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { LoanResponse } from '@/types/api.types';

interface DeleteConfirmationModalProps {
  loan: LoanResponse | null;
  onConfirm: (loan: LoanResponse) => void;
  onCancel: () => void;
}

export const DeleteConfirmationModal = ({
  loan,
  onConfirm,
  onCancel,
}: DeleteConfirmationModalProps) => {
  if (!loan) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-11/12 max-w-md shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <div className="flex items-center justify-center mb-4">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <Trash2 className="h-6 w-6 text-red-600" />
            </div>
          </div>
          <div className="text-center">
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Delete Loan
            </h3>
            <p className="text-sm text-gray-500 mb-4">
              Are you sure you want to delete the loan "
              <span className="font-medium">{loan.loan_name}</span>
              "? This action cannot be undone.
            </p>
            <div className="flex justify-center gap-4">
              <Button variant="outline" onClick={onCancel}>
                Cancel
              </Button>
              <Button variant="destructive" onClick={() => onConfirm(loan)}>
                Delete Loan
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
